import React from 'react';
import DigitalWalletButton from './DigitalWalletButton';
import { Separator } from '@vaiu/ui/separator';

interface PaymentMethodDigitalWalletProps {
  amount: number;
  currency: string;
  onPaymentSuccess: (paymentMethod: any) => void;
  onPaymentError?: (error: Error) => void;
  disabled?: boolean;
  className?: string;
  showSeparator?: boolean;
}

/**
 * PaymentMethodDigitalWallet - Wrapper for DigitalWalletButton
 * Provides Apple Pay / Google Pay functionality
 */
export const PaymentMethodDigitalWallet: React.FC<PaymentMethodDigitalWalletProps> = ({
  amount,
  currency,
  onPaymentSuccess,
  onPaymentError,
  disabled = false,
  className,
  showSeparator = true
}) => {
  if (amount <= 0) {
    return null;
  }

  return (
    <div className={className}>
      {showSeparator && (
        <div className="flex items-center gap-4 my-4">
          <Separator className="flex-1" />
          <span className="text-sm text-muted-foreground">OR</span>
          <Separator className="flex-1" />
        </div>
      )}
      
      <DigitalWalletButton
        amount={amount}
        currency={currency}
        label="Total"
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentError}
        disabled={disabled}
        showFallback={true}
      />
    </div>
  );
};

